import { Injectable } from '@angular/core';
import { ErrorTrackingErrorHandler, ErrorTrackingService } from '@spotlight/shared/error-tracking';
import { AnalyticsService } from '../analytics';

/** Reports uncaught errors to Bugsnag (shared handler) and sends the `Console Error Thrown` Amplitude event. */
@Injectable()
export class ConsoleErrorHandlerService extends ErrorTrackingErrorHandler {
  constructor(
    private readonly analytics: AnalyticsService,
    errorTracking: ErrorTrackingService
  ) {
    super(errorTracking);
  }

  protected override afterHandled(errorObj: Error): void {
    this.analytics.sendEvent(
      'Console Error Thrown',
      {
        error: errorObj.message || 'Undefined Error',
        stackTrace: errorObj.stack || 'Undefined Stack'
      }
    );
  }
}
